export default {
      id: "arrowDownRed-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "icons.svg#arrowDownRed",
      toString: function () {
        return this.url;
      }
    }